// IndexedDB storage: map bundles downloaded from the server (so a map is only
// downloaded once per version), map thumbnails taken by the game for maps
// without a levelshot, and the user pk3s of older versions (no longer used).

const DB_NAME = 'tjgame';
const DB_VERSION = 3;
const PK3_STORE = 'pk3';
const THUMB_STORE = 'thumbs';
const BUNDLE_STORE = 'bundles';

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      for (const name of [PK3_STORE, THUMB_STORE, BUNDLE_STORE]) if (!req.result.objectStoreNames.contains(name)) req.result.createObjectStore(name);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function run<T>(storeName: string, mode: IDBTransactionMode, fn: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return openDb().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const tx = db.transaction(storeName, mode);
        const req = fn(tx.objectStore(storeName));
        tx.oncomplete = () => {
          db.close();
          resolve(req.result);
        };
        tx.onerror = () => {
          db.close();
          reject(tx.error);
        };
      }),
  );
}

function blobStore(storeName: string) {
  return {
    save: (name: string, blob: Blob) => run(storeName, 'readwrite', (s) => s.put(blob, name)),
    remove: (name: string) => run(storeName, 'readwrite', (s) => s.delete(name)),
    names: () => run(storeName, 'readonly', (s) => s.getAllKeys()).then((keys) => keys.map(String)),
    load: (name: string) => run<Blob | undefined>(storeName, 'readonly', (s) => s.get(name)),
  };
}

export const storedPk3 = blobStore(PK3_STORE);
/** Map name -> JPEG thumbnail (480x270) captured in game. */
export const storedThumbs = blobStore(THUMB_STORE);
/** Bundle file name ("<map>-<crc>.pk3") -> the bundle. */
export const storedBundles = blobStore(BUNDLE_STORE);
